import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/pt";
import "./App.css";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import {
  InvoicesPage,
  StatisticsPage,
  ExportPage,
  ExpenseReportPage,
  CompaniesPage,
  BankStatementsPage,
  MatchingDashboardPage,
  ManualMatchingPage,
  PendingMatchesPage,
  AdvancedMatchingPage,
  LoginPage,
} from "./pages";

const theme = createTheme({
  palette: {
    primary: {
      main: "#2E7D63",
    },
    secondary: {
      main: "#FF6B35",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt">
          <Routes>
            {/* Public route - Login */}
            <Route path="/login" element={<LoginPage />} />

            {/* Protected routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<InvoicesPage />} />
              <Route path="statistics" element={<StatisticsPage />} />
              <Route path="export" element={<ExportPage />} />
              <Route path="expense-report" element={<ExpenseReportPage />} />
              <Route path="companies" element={<CompaniesPage />} />
              <Route path="bank-statements" element={<BankStatementsPage />} />
              <Route
                path="matching-dashboard"
                element={<MatchingDashboardPage />}
              />
              <Route
                path="manual-matching"
                element={<ManualMatchingPage />}
              />
              <Route
                path="pending-matches"
                element={<PendingMatchesPage />}
              />
              <Route
                path="advanced-matching"
                element={<AdvancedMatchingPage />}
              />
            </Route>

            {/* Catch all - redirect to login */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </LocalizationProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
